import get from 'lodash/get';

import { getFilter } from './index';

export default state => {
  const filtersInReducer = get(state, 'shops.shared.filters', {});
  return Object.keys(filtersInReducer).map(key => getFilter(key)(state));
};
